<template>
    <div id="atlas">
        <section class="menu_ctrl">
            <span class="text">選擇資料</span>
            <!-- 選擇資料 右側的icon -->
            <div class="icon-container">
                <QpeTooltip>
                    <template #hovered_item>
                        <v-icon 
                            color="white"
                            @click="close_all"
                        >
                            icon-unfold-less
                        </v-icon>
                    </template>
                    <template #tooltip_content>
                        <span>{{ $t('__map_obs.close_all_tree') }}</span>
                    </template>
                </QpeTooltip>
            </div>
        </section>
        <div class="atlas_treeview">
            <TreeView
                v-if="init_items.length > 0"
                ref="child_treeview"
                :current_tab="'atlas'"
                :init_items="init_items"
                :checked_selectors="checked_selectors"
                :init_opened_layers="[]"
                :check_function="change_atlas_type"
            />
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'
    import { MENU_ICON } from '@/config/menu_config.js';
    import TreeView from '../../tree_view.vue'
    export default {
        name: 'AtlasMenu',
        
        components: {
            TreeView,
            QpeTooltip: () => import('@/components/tool/qpe_tooltip.vue'),
        },

        props: {
            atlas_menu_data: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                init_opened_layers: [], // 預設右側導覽列要打開的選項
                init_items: [], // 右側導覽列選單資料
                checked_selectors: {},
                init_checked_value: '',
            }
        },
    
        created() {
            this.initialize()
        },

        methods: {
            ...mapMutations('atlas', {
                set_atlas_checked_selector: 'set_checked_selector'
            }),

            initialize() {
                // 在 main.vue 為了判斷是否啟用 atlas 已經事先取好 api
                try {
                    this._reconstruct_atlas_data(this.atlas_menu_data);
                    if (this.init_checked_selector) {
                        this.set_atlas_checked_selector(this.init_checked_selector)       
                    } else {
                        const first_selector = Object.values(this.checked_selectors)[0]
                        first_selector.checked = true
                        this.set_atlas_checked_selector(first_selector)
                    }
                    
                } catch(err) {
                    console.error(err)
                }
            },

            _reconstruct_atlas_data(menu_data) {
                this.init_opened_layers = Object.keys(menu_data)
                const items_groupby_layer1 = this.init_opened_layers.map(node_name => {
                    return {
                        'id': node_name + '_root',
                        'name': node_name, 
                        'values': menu_data[node_name]
                    }
                })
                
                const layers = this.init_opened_layers.map((layer_name, i) => {
                    const results_groupby_layer1 = this._generate_layer2(items_groupby_layer1[i]);
                    const main_item = {
                        'id': layer_name + '_root',
                        'name':layer_name, 
                        'node':true, 
                        'layer1':true, 
                        'radio_name': `${layer_name}root`,
                        'children': results_groupby_layer1,
                        'icon': MENU_ICON[layer_name]
                    }
                    return main_item
                })

                this.init_opened_layers = this.init_opened_layers.map(x => x + '_root');
                this.checked_selectors = this._generate_checked_property(menu_data); 
                this.init_items = layers;
            },

            _generate_layer2(layer1_group_data) {
                return layer1_group_data['values'].map((group_datum, i) => {
                    return {
                        'id': `atlas_${group_datum['value']}`,
                        'name': group_datum['text'],
                        'node': false, 
                        'type': 'cross_type_single_radio',
                        'layer1': false,
                        'radio_name': layer1_group_data['name'],
                        'index': i,
                    }
                })
            },

            _generate_checked_property(source_items) {
                let return_selectors = {}
                Object.values(source_items).forEach(selectors => {
                    selectors.forEach(selector => {
                        const id = `atlas_${selector['value']}` 
                        const checked_property = {
                            id,
                            'checked': selector['default_checked'] ?? false,
                        }
                        if(selector['default_checked']) {
                            this.init_checked_selector = selector
                        }
                        return_selectors[id] = {...selector, ...checked_property}
                    })
                })
                return return_selectors
            },

            change_atlas_type(id) {
                this.set_atlas_checked_selector(this.checked_selectors[id])
            },
            
            close_all() {
                this.$refs.child_treeview.close_all_trees();
            },
        },
    }
</script>

<style lang="scss" scoped>
    .atlas_treeview {
        overflow-y: auto;
        height: calc(100vh - 30px);
        background: var(--base-gray);
    }

    .menu_ctrl {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 3px;
        background: var(--base-gray-darken);
        touch-action: none;
    }

    .text {
        color: var(--grey-pipe);
    }
</style>